"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_HTTP_REQUESTS = exports.EMAIL_REGEX = exports.DEFAULT_NOTIFICATION_DELIVERY_CHANNEL = exports.DEFAULT_NOTIFICATION_CLASSIFICATION = void 0;
const notifications_sdk_1 = require("@bondsports/notifications-sdk");
exports.DEFAULT_NOTIFICATION_CLASSIFICATION = notifications_sdk_1.NotificationClassification.TRANSACTIONAL;
exports.DEFAULT_NOTIFICATION_DELIVERY_CHANNEL = notifications_sdk_1.NotificationDeliveryChannel.EMAIL;
exports.EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
exports.MAX_HTTP_REQUESTS = 10;
//# sourceMappingURL=notification.consts.js.map